import React, { useEffect } from "react"
import { Select, Space, Typography, Avatar } from "antd"
import { UserOutlined } from "@ant-design/icons"
import { connect } from "react-redux"
import { getListExecutor } from "store/actions"

const { Text } = Typography

const ListExecutor = ({ lstExecutor, onGetListExecutor, selectedUserId, onSelectUser }) => {
  useEffect(() => {
    onGetListExecutor()
  }, [])

  const handleChange = value => {
    onSelectUser(value !== undefined ? value : null)
  }

  return (
    <Space direction="vertical" style={{ width: "100%" }}>
      <Text type="secondary">انتخاب مجری برای مشاهده تراکنش‌ها:</Text>
      <Select
        allowClear
        showSearch
        placeholder="همه مجریان"
        style={{ width: "100%", maxWidth: 400 }}
        value={selectedUserId || undefined}
        onChange={handleChange}
        filterOption={(input, option) =>
          (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
        }
        options={(lstExecutor || []).map(user => ({
          value: user.userId,
          label: user.fullName || user.userName,
        }))}
        optionRender={option => (
          <Space>
            <Avatar size="small" icon={<UserOutlined />} />
            <Text>{option.label}</Text>
          </Space>
        )}
      />
      {selectedUserId && (
        <Text type="secondary" style={{ fontSize: 12 }}>
          نمایش تراکنش‌های مجری انتخاب شده
        </Text>
      )}
    </Space>
  )
}

const mapStateToProps = ({ Executors }) => ({
  lstExecutor: Executors.lstExecutor,
})

const mapDispatchToProps = dispatch => ({
  onGetListExecutor: () => dispatch(getListExecutor()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListExecutor)
